import type {
  ActiveSchedulesDashboardAction,
  ActiveSchedulesDashboardState,
} from '../types';

export const initialState: ActiveSchedulesDashboardState = {
  drawerState: {
    users: false,
    events: false,
  },
  selectedSchedule: null,
  selectedTriggers: [],
};

export const reducer = (
  state: ActiveSchedulesDashboardState,
  action: ActiveSchedulesDashboardAction,
): ActiveSchedulesDashboardState => {
  switch (action.type) {
    case 'SET_FILTERS':
      return { ...state, filters: action.payload };

    case 'TOGGLE_DRAWER': {
      const drawerState = {
        ...state.drawerState,
        [action.payload]: !state.drawerState[action.payload],
      };
      return { ...state, drawerState };
    }

    case 'SET_SELECTED_SCHEDULE':
      return { ...state, selectedSchedule: action.payload };

    case 'SET_SELECTED_TRIGGERS':
      return { ...state, selectedTriggers: action.payload };

    default:
      return state;
  }
};
